import React, { useState } from "react";

import Context from "./index";
import { alertSuccess } from "../../../Shared/Utils/alertMessages.js";
import {
  errorDeleteingData,
  errorGettingData,
  errorInsertingData,
  errorUpdatingData,
  ItemCreated,
  ItemUpdated,
  successDeleted,
} from "../../../Shared/Constants/index.jsx";

import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils.js";
import { postCall } from "../../../Shared/Api/PostApi.js";
import { UserApi } from "../../../Shared/Constants/api.js";
import { putCall } from "../../../Shared/Api/PutApi.js";
import { deleteCall } from "../../../Shared/Api/DeleteApi.js";
import { getCall } from "../../../Shared/Api/GetApi.js";

const UserProvider = (props) => {
  const [tableData, setTableData] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const modalTogle = () => {
    setModal(!modal);
  };
  //List objects frokm db
  const fetchTableData = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getCall(`${UserApi}`, {
        search: searchTerm,
        page: page,
        limit: limit,
        //...filters,
      });
      let data = response.data;

      if (response.result === "success") {
        setTableData(data.items); // Append new data
        setTotalRows(data.totalRows); // Append new data
      } else {
        setTableData([]); // Append new data
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertToastErrorFromResponse(errorGettingData, error);
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createItem = async (data) => {
    setSaving(true);
    let response = await postCall(`${UserApi}`, data);

    if (response?.result && response?.result == "success") {
      alertSuccess(ItemCreated);

      fetchTableData(currentPage, rowsPerPage);
      modalTogle();
      setApiErrors([]);
    } else {
      alertToastErrorFromResponse(errorInsertingData, response);
    }

    setSaving(false);
  };

  //edit item
  const updateItem = async (data, id) => {
    setSaving(true);
    let response = await putCall(`${UserApi}/${id}`, data);

    if (response?.result && response?.result == "success") {
      fetchTableData(currentPage, rowsPerPage);
      alertSuccess(ItemUpdated);
      modalTogle();
      setApiErrors([]);
    } else {
      alertToastErrorFromResponse(errorUpdatingData, response);
    }

    setSaving(false);
  };

  //delete item
  const deleteItem = async (id) => {
    setLoading(true);
    let response = await deleteCall(`${UserApi}/${id}`);

    if (response?.result && response?.result == "success") {
      const newdata = tableData.filter((elem) => {
        return id !== elem.id;
      });
      setTableData(newdata);
      alertSuccess(successDeleted);
    } else {
      alertToastErrorFromResponse(errorDeleteingData, response);
    }
    setLoading(false);
  };

  const handleEdit = async (row) => {
    let editObject = tableData.find((e) => e.id === row.id);
    setItem(editObject);
    setApiErrors([]);
  };

  return (
    <Context.Provider
      value={{
        ...props,
        tableData,
        createItem,
        updateItem,
        deleteItem,
        fetchTableData,
        setCurrentPage,
        setRowsPerPage,
        setLoading,
        apiErrors,
        modalTogle,
        modal,
        setItem,
        item,
        loading,
        currentPage,
        totalRows,
        handleEdit,
        rowsPerPage,
        searchTerm,
        setSearchTerm,
        saving,
        setSaving,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default UserProvider;
